/**
 * Course and pack cover URL from the `cover` field only.
 * Does not build legacy api.refreps.com/images/{id}.webp paths.
 */
export function catalogCoverSrc(item) {
  if (typeof item === 'string') return item.trim()
  const cover = item?.cover
  return typeof cover === 'string' ? cover.trim() : ''
}

/**
 * Resolve cover from the item, or by matching `id` in one or more catalogs.
 */
export function catalogCoverSrcFromCatalogs(itemOrId, catalogs = []) {
  const direct = typeof itemOrId === 'object' ? catalogCoverSrc(itemOrId) : ''
  if (direct) return direct
  const id = typeof itemOrId === 'object' ? itemOrId?.id : itemOrId
  if (id == null || id === '') return ''
  const lists = Array.isArray(catalogs) ? catalogs : [catalogs]
  for (const list of lists) {
    if (!Array.isArray(list)) continue
    const match = list.find((entry) => entry && String(entry.id) === String(id))
    const cover = catalogCoverSrc(match)
    if (cover) return cover
  }
  return ''
}
